<template>
  <div>
    <SettingGroup title="SSID">
      <BCListBox
        :items="items"
        @update:items="items = $event"
        :disableAdd="disableSave"
        :disableNewSelection="disableNewSelection"
        :maxItems="LIST_BOX_ITEMS_MAX"
        :labelMaxBytes="LIST_BOX_LABEL_BYTES_MAX"
        @delete="handleRequestDeleteItem"
        @add="handleAddItem"
        @select="handleSelectItem"
        @typing="handleTypingItemLabel"
        @confirmed="handleConfirmedItemLabel"
        @invalidLabels="handleInvalidLabels"
      />
    </SettingGroup>

    <SettingGroup title="詳細設定">
      <SettingItem label="セキュリティ設定">
        <SelectBox
          :disabled="isEmptyStr(selectedItem && selectedItem.label)"
          :options="selectboxOptions.wiFiManagementList.securityType"
          :defaultValue="form.selectbox.wiFiManagementList.securityType"
          @update="handleSelectSecurityType"
        />
      </SettingItem>

      <SettingItem label="パスワード">
        <el-form :model="form.password" :rules="rules" ref="formWiFiPasswordRef">
          <FormPasswordBox
            v-if="showPasswordBox"
            :disabled="isEmptyStr(selectedItem && selectedItem.label) || isEnhancedOpen"
            :input-value="form.password.wiFiPassword"
            label=""
            :showPassword="true"
            prop="wiFiPassword"
            class="wiFiPasswordBox"
            @update:inputValue="val => (form.password.wiFiPassword = val)"
          />
        </el-form>
      </SettingItem>

      <SettingItem label="自動接続設定">
        <ToggleSwitch
          v-model="form.toggle.wiFiManagementList.autoConnectSetting"
          :disable="isEmptyStr(selectedItem && selectedItem.label)"
        />
      </SettingItem>

      <SettingItem label="IP割り当て設定">
        <RadioGroup
          v-model="form.radioBtn.wiFiManagementList.ipAssignment"
          :options="radioBtnOptions.wiFiManagementList.ipAssignment"
          :disable="isEmptyStr(selectedItem && selectedItem.label)"
        />
      </SettingItem>

      <SettingItem label="IPアドレス">
        <el-form :model="form.text" :rules="rules" ref="formIpAddressRef">
          <FormTextBox
              v-model="form.text.ipAddress"
              label=""
              :disable="isEmptyStr(selectedItem && selectedItem.label) || isDHCP"
              :required="false"
              class="messageTypeTextBox"
              prop="ipAddress"
              placeholder="入力してください"
          />
        </el-form>
      </SettingItem>

      <SettingItem label="サブネットマスク">
        <el-form :model="form.text" :rules="rules" ref="formSubnetMaskRef">
          <FormTextBox
            v-model="form.text.subnetMask"
            label=""
            :disable="isEmptyStr(selectedItem && selectedItem.label) || isDHCP"
            :required="false"
            class="messageTypeTextBox"
            prop="subnetMask"
            placeholder="入力してください"
          />
        </el-form>
      </SettingItem>

      <SettingItem label="デフォルトゲートウェイ">
        <el-form :model="form.text" :rules="rules" ref="formDefaultGatewayRef">
          <FormTextBox
            v-model="form.text.defaultGateway"
            label=""
            :disable="isEmptyStr(selectedItem && selectedItem.label) || isDHCP"
            :required="false"
            class="messageTypeTextBox"
            prop="defaultGateway"
            placeholder="入力してください"
          />
        </el-form>
      </SettingItem>

        <SettingItem label="プライマリDNSサーバ">
            <el-form :model="form.text" :rules="rules" ref="formPrimaryDNSServerRef">
                <FormTextBox
                    v-model="form.text.primaryDNSServer"
                    label=""
                    :disable="isEmptyStr(selectedItem && selectedItem.label) || isDHCP"
                    :required="false"
                    class="messageTypeTextBox"
                    prop="primaryDNSServer"
                    placeholder="入力してください"
                />
            </el-form>
        </SettingItem>

        <SettingItem label="セカンダリDNSサーバ">
            <el-form :model="form.text" :rules="rules" ref="formSecondaryDNSServerRef">
                <FormTextBox
                    v-model="form.text.secondaryDNSServer"
                    label=""
                    :disable="isEmptyStr(selectedItem && selectedItem.label) || isDHCP"
                    :required="false"
                    class="messageTypeTextBox"
                    prop="secondaryDNSServer"
                    placeholder="入力してください"
                />
            </el-form>
        </SettingItem>
    </SettingGroup>

  　<DeleteObject
      v-if="showBCWiFiSettingDelDialog"
      :confirmInfo="{objectTitle: 'Wi-Fi設定', objectName: deleteTargetItem.label }"
      @delete="handleDeleteItem(deleteTargetItem)"
      @cancel="handleCancelDeleteDialog"/>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import FormPasswordBox from '@/components/pc/radio/ipradio/atoms/FormPasswordBox.vue'
import FormTextBox from '@/components/pc/radio/ipradio/atoms/FormTextBox.vue'
import RadioGroup from '@/components/pc/radio/ipradio/atoms/RadioGroup.vue'
import SelectBox from '@/components/pc/radio/ipradio/atoms/SelectBox.vue'
import ToggleSwitch from '@/components/pc/radio/ipradio/atoms/ToggleSwitch.vue'
import BCListBox from '@/components/pc/radio/ipradio/organisms/BCListBox.vue'
import SettingGroup from '@/components/pc/radio/ipradio/organisms/layout/SettingGroup.vue'
import SettingItem from '@/components/pc/radio/ipradio/organisms/layout/SettingItem.vue'
import DeleteObject from "@/components/DeleteObject.vue";
import { BC, BC_TRANS_JP, SUBNET_MASK_LIST } from '@/components/pc/radio/ipradio/config/BCconstants'
import { useRadioSettingsStore } from '@/components/pc/radio/ipradio/stores/bcRadioSettings'
import { mapStores } from 'pinia'
import commonUtil from '../../../../../../commonutil.js'

// ★ 既定値は工場関数で毎回新規生成（参照共有と undefined を回避）
function makeDefaultWifiSetting () {
  return {
      SecurityType: 'WPA3',
      'Wi-FiPassword': null,
      AutoConnectSetting: 'Enable',
      IPAssignment: 'DHCP',
      IPAddress: '192.168.0.1',
      SubnetMask: '255.255.255.0',
      DefaultGateway: '192.168.0.254',
      PrimaryDNSServer: '',
      SecondaryDNSServer: '',
  }
}

export default {
  name: 'WifiManagementListVue2',
  components: {
    FormPasswordBox,
    FormTextBox,
    RadioGroup,
    SelectBox,
    ToggleSwitch,
    BCListBox,
    SettingGroup,
    SettingItem,
    DeleteObject,
  },
  data () {
    // 定数
    const FORBIDDEN_PASSWORD_PATTERN = /[^\x21-\x7E]/
    const IP_V4_PATTERN =
      /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/
    const PASSWORD_LEN_MIN = 8
    const PASSWORD_LEN_MAX = 63

    const LIST_BOX_ITEMS_MAX = 20
    const LIST_BOX_LABEL_BYTES_MAX = 32

    // 選択肢
    const radioBtnOptions = {
      wiFiManagementList: {
        ipAssignment: Object.keys(BC.NETWORK.WIFI_MANAGEMENT_LIST.IP_ASSIGNMENT).map(key => ({
          label: BC_TRANS_JP.NETWORK.WIFI_MANAGEMENT_LIST.IP_ASSIGNMENT[key],
          value: BC.NETWORK.WIFI_MANAGEMENT_LIST.IP_ASSIGNMENT[key],
        })),
      },
    }
    const selectboxOptions = {
      wiFiManagementList: {
        securityType: Object.keys(BC.NETWORK.WIFI_MANAGEMENT_LIST.SECURITY_TYPE).map(key => {
          const v = BC.NETWORK.WIFI_MANAGEMENT_LIST.SECURITY_TYPE[key]
          const label = v === BC.NETWORK.WIFI_MANAGEMENT_LIST.SECURITY_TYPE.ENHANCED_OPEN
            ? commonUtil.camelToSpacedTitleCase(v)
            : v
          return { label, value: v }
        }),
      },
    }

    return {
      // 公開定数（templateで使用）
      LIST_BOX_ITEMS_MAX,
      LIST_BOX_LABEL_BYTES_MAX,

      // オプション
      radioBtnOptions,
      selectboxOptions,

      // フォーム
      form: {
        radioBtn: {
          wiFiManagementList: {
            ipAssignment: radioBtnOptions.wiFiManagementList.ipAssignment[0].value,
          },
        },
        selectbox: {
          wiFiManagementList: {
            securityType: selectboxOptions.wiFiManagementList.securityType[0].value,
          },
        },
        toggle: {
          wiFiManagementList: {
            autoConnectSetting: false,
          },
        },
        text: {
            ipAddress: null,
            subnetMask: null,
            defaultGateway: null,
            primaryDNSServer: null,
            secondaryDNSServer: null,

        },
        password: {
          wiFiPassword: null,
        },
      },

      // UI/状態
      items: [],
      selectedItem: null,
      deleteTargetItem: null,
      invalidLabels: false,
      showPasswordBox: true,
      showBCWiFiSettingDelDialog: false,

      // 入力チェック状態
      isInvalidPasswordBox: { wiFiPassword: false },
      isInvalidTextBox: { ipAddress: false, subnetMask: false, defaultGateway: false, primaryDNSServer: false, secondaryDNSServer: false },

        // refs（Vue2 は this.$refs でアクセス）
        formWiFiPasswordRef: null,
        formIpAddressRef: null,
        formSubnetMaskRef: null,
        formDefaultGatewayRef: null,
        formPrimaryDNSServerRef: null,
        formSecondaryDNSServerRef: null,

      // ストア設定
      setting: null,
      pendingItem: makeDefaultWifiSetting(), // ★ 初期化を関数で

      // バリデーション定義（created で this を使ってセット）
      rules: {},

      // バリデーション用定数
      FORBIDDEN_PASSWORD_PATTERN,
      IP_V4_PATTERN,
      PASSWORD_LEN_MIN,
      PASSWORD_LEN_MAX,
    }
  },

  computed: {
    BC() { return BC },

    ...mapStores(useRadioSettingsStore),

    // DHCPかどうか
    isDHCP () {
      return this.form.radioBtn.wiFiManagementList.ipAssignment ===
        BC.NETWORK.WIFI_MANAGEMENT_LIST.IP_ASSIGNMENT.DHCP
    },

    // セキュリティが Enhanced Open か
    isEnhancedOpen () {
      return this.form.selectbox.wiFiManagementList.securityType ===
        BC.NETWORK.WIFI_MANAGEMENT_LIST.SECURITY_TYPE.ENHANCED_OPEN
    },

    // 新規選択の活性/非活性
    disableNewSelection () {
      return this.isInvalidPasswordBox.wiFiPassword ||
          this.isInvalidTextBox.ipAddress ||
          this.isInvalidTextBox.subnetMask ||
          this.isInvalidTextBox.defaultGateway ||
          this.isInvalidTextBox.primaryDNSServer ||
          this.isInvalidTextBox.secondaryDNSServer
    },

    // 保存ボタンの活性/非活性（親へ emit）
    disableSave () {
      return this.disableNewSelection || this.invalidLabels
    },
  },

  created () {
    // ストアから設定取得
    this.setting = this.radioSettingsStore.getTempSetting()

    // items 初期化
    this.items = (this.setting.Network['Wi-FiManagementList'] || []).map(w => ({
      label: w.SSID,
      value: w.SSID,
      _id: uuidv4(),
      data: w,
    }))

    // ルール（this 参照が必要なため created で定義）
    this.rules = {
        wiFiPassword: [{ validator: this.validatePasswordBox, trigger: 'change' }],
        ipAddress:    [{ validator: this.validateTextBox,     trigger: ['blur', 'change'] }],
        subnetMask:   [{ validator: this.validateTextBoxForSubnet,     trigger: ['blur', 'change'] }],
        defaultGateway: [{ validator: this.validateTextBox,   trigger: ['blur', 'change'] }],
        primaryDNSServer: [{ validator: this.validateTextBox,   trigger: ['blur', 'change'] }],
        secondaryDNSServer: [{ validator: this.validateTextBox,   trigger: ['blur', 'change'] }],
    }

    // 設定 → フォーム（新規は pendingItem を参照）
    this.transSetting2Form(null)

    // フォーム監視：設定へ反映 & 保存
    this.$watch('form', () => {
      const index = this.hasOwn(this.selectedItem, 'data') ? this.getSelectedItemIndex() : null
      this.transForm2Setting(index)
      this.radioSettingsStore.saveTempSetting(this.setting)
    }, { deep: true })

    // 入力制限（テキストボックス）：半角数字と '.' のみ、先頭は 0 / '.' を不可（入力時に除去）
    this.$watch('form.text.ipAddress', (val) => {
      const filtered = this.filterIpLikeInput(val)
      if ((val == null ? '' : String(val)) !== filtered) this.form.text.ipAddress = filtered
    })
    this.$watch('form.text.subnetMask', (val) => {
      const filtered = this.filterIpLikeInput(val)
      if ((val == null ? '' : String(val)) !== filtered) this.form.text.subnetMask = filtered
    })
    this.$watch('form.text.defaultGateway', (val) => {
      const filtered = this.filterIpLikeInput(val)
      if ((val == null ? '' : String(val)) !== filtered) this.form.text.defaultGateway = filtered
    })
    this.$watch('form.text.primaryDNSServer', (val) => {
      const filtered = this.filterIpLikeInput(val)
      if ((val == null ? '' : String(val)) !== filtered) this.form.text.primaryDNSServer = filtered
    })
    this.$watch('form.text.secondaryDNSServer', (val) => {
      const filtered = this.filterIpLikeInput(val)
      if ((val == null ? '' : String(val)) !== filtered) this.form.text.secondaryDNSServer = filtered
    })

    // 個別フィールドの監視（バリデーション）
    this.$watch('form.selectbox.wiFiManagementList.securityType', async () => {
      if (this.$refs.formWiFiPasswordRef) this.$refs.formWiFiPasswordRef.validate()
    })

    this.$watch('form.radioBtn.wiFiManagementList.ipAssignment', async () => {
        if (this.$refs.formIpAddressRef) this.$refs.formIpAddressRef.validate()
        if (this.$refs.formSubnetMaskRef) this.$refs.formSubnetMaskRef.validate()
        if (this.$refs.formDefaultGatewayRef) this.$refs.formDefaultGatewayRef.validate()
        if (this.$refs.formPrimaryDNSServerRef) this.$refs.formPrimaryDNSServerRef.validate()
        if (this.$refs.formSecondaryDNSServerRef) this.$refs.formSecondaryDNSServerRef.validate()
    })

    this.$watch('selectedItem', async () => {
        if (this.$refs.formWiFiPasswordRef) this.$refs.formWiFiPasswordRef.validate()
        if (this.$refs.formIpAddressRef) this.$refs.formIpAddressRef.validate()
        if (this.$refs.formSubnetMaskRef) this.$refs.formSubnetMaskRef.validate()
        if (this.$refs.formDefaultGatewayRef) this.$refs.formDefaultGatewayRef.validate()
        if (this.$refs.formPrimaryDNSServerRef) this.$refs.formPrimaryDNSServerRef.validate()
        if (this.$refs.formSecondaryDNSServerRef) this.$refs.formSecondaryDNSServerRef.validate()
    })

    // 親へ disableSave を通知（初回も通知）
    this.$watch('disableSave', (val) => {
      this.$emit('disableSave', val)
    }, { immediate: true })
  },

  methods: {
    // ユーティリティ
    isEmptyStr (v) { return v === undefined || v === null || v === '' },
    hasOwn (obj, prop) { return obj != null && Object.prototype.hasOwnProperty.call(obj, prop) },

    // 入力制限：半角数字と '.' のみ、先頭は 0 / '.' を許可しない（入力時に除去）
    filterIpLikeInput (raw) {
      const s = raw == null ? '' : String(raw)
      // 半角数字とドット以外を除去
      let out = s.replace(/[^0-9.]/g, '')
      // 先頭の 0 / '.' を除去（連続する場合も除去）
      out = out.replace(/^[0.]+/, '')
      return out
    },

    // 先頭オクテット（"a.b.c.d" の a）を数値として返す。取得できない場合は null。
    getFirstOctet (ipLike) {
      const s = ipLike == null ? '' : String(ipLike)
      const first = s.split('.')[0]
      if (first === '' || !/^[0-9]+$/.test(first)) return null
      const n = Number(first)
      return Number.isFinite(n) ? n : null
    },

    // IPv4 を 32bit uint に変換（不正なら null）
    ipV4ToInt (ip) {
      const s = ip == null ? '' : String(ip).trim()
      if (!this.IP_V4_PATTERN.test(s)) return null
      const parts = s.split('.').map(n => Number(n))
      if (parts.length !== 4 || parts.some(n => !Number.isFinite(n) || n < 0 || 255 < n)) return null
      return (((parts[0] << 24) >>> 0) + (parts[1] << 16) + (parts[2] << 8) + parts[3]) >>> 0
    },

    // サブネットマスクとして妥当（許可リストに存在）か
    isValidSubnetMask (subnetMask) {
      const s = subnetMask == null ? '' : String(subnetMask).trim()
      return SUBNET_MASK_LIST.includes(s)
    },

    // IP と SubnetMask の組み合わせチェック（問題なければ空文字を返す）
    // - ホスト部が全て1（ブロードキャスト）
    // - IP | Mask が Mask と一致（ホスト部が全て0＝ネットワークアドレス相当）
    // - IP & Mask が 0（ネットワーク部が全て0）
    validateIpAndSubnetMaskPair (ip, subnetMask) {
      const ipInt = this.ipV4ToInt(ip)
      const maskInt = this.ipV4ToInt(subnetMask)
      if (ipInt == null || maskInt == null) return ''
      if (!this.isValidSubnetMask(subnetMask)) return ''

      const hostMask = (~maskInt) >>> 0
      const hostPart = (ipInt & hostMask) >>> 0

      const COMMON_MSG = 'IPアドレスとサブネットマスクの組み合わせが正しくありません。'

      // ① ホストアドレスが全て1（ブロードキャストアドレス）
      if (hostMask !== 0 && hostPart === hostMask) return COMMON_MSG

      // ② IPAddress と SubnetMask の OR 結果が SubnetMask と一致
      //    （ホスト部が全て0になるケース）
      if ((((ipInt | maskInt) >>> 0) === (maskInt >>> 0))) return COMMON_MSG

      // ③ IPAddress と SubnetMask の AND 結果が全て0
      if ((((ipInt & maskInt) >>> 0) === 0)) return COMMON_MSG

      return ''
    },

    // 設定 ← フォーム
    transForm2Setting (index) {
        const data = (index == null)
          ? this.pendingItem
          : this.setting.Network['Wi-FiManagementList'][index]

        data.SecurityType = this.form.selectbox.wiFiManagementList.securityType
        data['Wi-FiPassword'] = this.form.password.wiFiPassword || null
        data.AutoConnectSetting = this.form.toggle.wiFiManagementList.autoConnectSetting
          ? BC.COMMON.TOGGLE.ENABLE : BC.COMMON.TOGGLE.DISABLE
        data.IPAssignment = this.form.radioBtn.wiFiManagementList.ipAssignment
        data.IPAddress = this.form.text.ipAddress || null
        data.SubnetMask = this.form.text.subnetMask || null
        data.DefaultGateway = this.form.text.defaultGateway || null
        data.PrimaryDNSServer = this.form.text.primaryDNSServer || null
        data.SecondaryDNSServer = this.form.text.secondaryDNSServer || null
    },

    // 設定 → フォーム
    transSetting2Form (index) {
        const data = (index == null)
          ? this.pendingItem
          : this.setting.Network['Wi-FiManagementList'][index]

        this.form.selectbox.wiFiManagementList.securityType = data.SecurityType
        this.form.password.wiFiPassword = data['Wi-FiPassword'] || ''
        this.form.radioBtn.wiFiManagementList.ipAssignment = data.IPAssignment
        this.form.toggle.wiFiManagementList.autoConnectSetting =
          data.AutoConnectSetting === BC.COMMON.TOGGLE.ENABLE
        this.form.text.ipAddress = data.IPAddress
        this.form.text.subnetMask = data.SubnetMask
        this.form.text.defaultGateway = data.DefaultGateway
        this.form.text.primaryDNSServer = data.PrimaryDNSServer
        this.form.text.secondaryDNSServer = data.SecondaryDNSServer
    },

    // セキュリティ種別選択
    handleSelectSecurityType (value) {
      this.form.selectbox.wiFiManagementList.securityType = value
    },

    // 削除リクエスト
    handleRequestDeleteItem (item) {
      this.deleteTargetItem = item
      this.showBCWiFiSettingDelDialog = true
    },

    // 削除確定
    handleDeleteItem (item) {
      this.showBCWiFiSettingDelDialog = false
      this.deleteTargetItem = null
      if (item == null) return

      const itemIndex = this.items.findIndex(i => i._id === item._id)
      if (itemIndex !== -1) this.items.splice(itemIndex, 1)

      const settingIndex = this.getSettingIndexByItem(item)
      if (settingIndex == null) return
      this.setting.Network['Wi-FiManagementList'].splice(settingIndex, 1)
      this.radioSettingsStore.saveTempSetting(this.setting)
    },

    handleCancelDeleteDialog () {
      this.showBCWiFiSettingDelDialog = false
      this.deleteTargetItem = null
    },

    // 追加
    handleAddItem (item) {
      // 追加対象は pendingItem をベースに作成
      const newSetting = { ...this.pendingItem, SSID: item.label }
      this.setting.Network['Wi-FiManagementList'].push(newSetting)
      this.items.push({
        label: item.label,
        value: item.label,
        data: { ...newSetting },
        _id: uuidv4(),
      })
      // 既定値にリセット（毎回新規生成）
      this.pendingItem = makeDefaultWifiSetting()
    },

    // 選択
    async handleSelectItem (item) {
      await this.recreatePasswordBox()
      this.selectedItem = item
      const index = this.hasOwn(this.selectedItem, 'data') ? this.getSelectedItemIndex() : null
      this.transSetting2Form(index)
    },

    // ラベル編集中
    handleTypingItemLabel (item) {
      this.selectedItem = item
    },

    // ラベル確定
    handleConfirmedItemLabel (item) {
      this.selectedItem = item
      const settingIndex = this.hasOwn(this.selectedItem, 'data') ? this.getSelectedItemIndex() : null
      if (settingIndex == null) return
      const data = this.setting.Network['Wi-FiManagementList'][settingIndex]
      const itemIndex = this.items.findIndex(it => it.data.SSID === data.SSID)
      data.SSID = item.label
      this.items[itemIndex].label = data.SSID
      this.items[itemIndex].data.SSID = data.SSID
    },

    handleInvalidLabels (invalid) {
      this.invalidLabels = invalid
    },

    // 選択中アイテムの index
    getSelectedItemIndex () {
      return this.setting.Network['Wi-FiManagementList'].findIndex(
        w => w.SSID === (this.selectedItem && this.selectedItem.data && this.selectedItem.data.SSID)
      )
    },

    getSettingIndexByItem (item) {
      if (!this.hasOwn(item, 'data')) return null

      const settingIndex = this.setting.Network['Wi-FiManagementList'].findIndex(
        w => w.SSID === item.data.SSID
      )

      return settingIndex === -1 ? null : settingIndex
    },

    // バリデーション：パスワード
    validatePasswordBox (rule, value, callback) {
      if (this.isEmptyStr(this.selectedItem && this.selectedItem.label) || this.isEnhancedOpen) {
        this.isInvalidPasswordBox[rule.field] = false
        return callback()
      }

      let msg = ''
      if (value.length < this.PASSWORD_LEN_MIN || this.PASSWORD_LEN_MAX < value.length) {
        msg += '8文字以上63文字以下で入力してください。 '
      }
      if (this.FORBIDDEN_PASSWORD_PATTERN.test(value)) {
        msg += '半角英数記号を使用してください。 '
      }

      this.isInvalidPasswordBox[rule.field] = msg !== ''
      callback(msg === '' ? undefined : new Error(msg))
    },

    // バリデーション：テキスト（IPv4）
    validateTextBox (rule, value, callback) {
      if (this.isEmptyStr(this.selectedItem && this.selectedItem.label) || this.isDHCP) {
        this.isInvalidTextBox[rule.field] = false
        return callback()
      }

      let msg = ''
      const v = value == null ? '' : String(value).trim()
      const firstOctet = this.getFirstOctet(v)
      if (v === '') {
          msg += '値を指定してください。'
      } else if (v.startsWith('127.')) {
          msg += '127で始まるIPアドレスは、予約されたアドレスであるため使用できません。'
      } else if (v.startsWith('128.0')) {
          msg += '128.0で始まるIPアドレスは、予約されたアドレスであるため使用できません。'
      } else if (v.startsWith('191.255')) {
          msg += '191.255で始まるIPアドレスは、予約されたアドレスであるため使用できません。'
      } else if (v.startsWith('192.0.1')) {
          msg += '192.0.1で始まるIPアドレスは、予約されたアドレスであるため使用できません。'
      } else if (v.startsWith('223.255.255')) {
          msg += '223.255.255で始まるIPアドレスは、予約されたアドレスであるため使用できません。'
      } else if (firstOctet != null && firstOctet >= 224 && firstOctet <= 255) {
          msg += '224～255で始まるIPアドレスは使用できません。'
      } else if (!this.IP_V4_PATTERN.test(v)) {
          msg += 'IPv4形式で入力してください。'
      } else if (rule.field === 'ipAddress') {
          // IP / SubnetMask が両方妥当なときだけ、組み合わせチェックを行う
          const pairMsg = this.validateIpAndSubnetMaskPair(v, this.form.text.subnetMask)
          if (pairMsg) msg += pairMsg
      }
      this.isInvalidTextBox[rule.field] = msg !== ''
      callback(msg === '' ? undefined : new Error(msg))
    },

    validateTextBoxForSubnet (rule, value, callback) {
      if (this.isEmptyStr(this.selectedItem && this.selectedItem.label) || this.isDHCP) {
          this.isInvalidTextBox[rule.field] = false
          return callback()
      }

      let msg = ''
      const v = value == null ? '' : String(value).trim()
      const firstOctet = this.getFirstOctet(v)
      if (v === '') {
          msg += '値を指定してください。'
      } else if (!this.IP_V4_PATTERN.test(v)) {
          msg += 'IPv4形式で入力してください。'
      } else if (!SUBNET_MASK_LIST.includes(v)) {
          msg += '不正なサブネットマスクです。'
      } else {
          // IP / SubnetMask が両方妥当なときだけ、組み合わせチェックを行う
          const pairMsg = this.validateIpAndSubnetMaskPair(this.form.text.ipAddress, v)
          if (pairMsg) msg += pairMsg
      }
      this.isInvalidTextBox[rule.field] = msg !== ''
      callback(msg === '' ? undefined : new Error(msg))
    },

    // パスワードボックス再生成（強制的に非表示へ戻す）
    async recreatePasswordBox () {
      this.showPasswordBox = false
      await this.$nextTick()
      this.showPasswordBox = true
      await this.$nextTick()
    },
  },
}
</script>

<style scoped>
.wiFiPasswordBox { width: 450px; }

::v-deep .el-form-item__error {
    white-space: nowrap;
    width: max-content;
    max-width: none;
    overflow: visible;
}
</style>
